const NGNngpayOptions = [
    {
        value: "379",
        label: "9 PAYMENT SERVICE BANK",
    },
    {
        value: "130",
        label: "ABBEY MORTGAGE BANK PLC.",
    },
    {
        value: "485",
        label: "ABOVE ONLY MICROFINANCE BANK LTD",
    },
    {
        value: "362",
        label: "ABU MICROFINANCE BANK LTD",
    },
    {
        value: "059",
        label: "ABUCOOP MFB",
    },
    {
        value: "044",
        label: "ACCESS BANK NIGERIA PLC",
    },
    {
        value: "097",
        label: "ACCION MICROFINANCE BANK",
    },
    {
        value: "389",
        label: "ADA MFB",
    },
    {
        value: "469",
        label: "AFEMAI MICROFINANCE BANK LTD",
    },
    {
        value: "200",
        label: "AG MORTGAGE BANK PLC",
    },
    {
        value: "344",
        label: "AKUCHUKWU MICROFINANCE BANK",
    },
    {
        value: "483",
        label: "AKWA SAVINGS AND LOANS",
    },
    {
        value: "513",
        label: "ALLIANZ MFB",
    },
    {
        value: "317",
        label: "ALVANA MICROFINANCE BANK",
    },
    {
        value: "370",
        label: "AMAC MICROFINANCE BANK",
    },
    {
        value: "306",
        label: "AMJU UNIQUE MICROFINANCE BANK",
    },
    {
        value: "366",
        label: "AMML MICROFINANCE BANK",
    },
    {
        value: "476",
        label: "APEX TRUST MFB",
    },
    {
        value: "121",
        label: "ASO SAVINGS",
    },
    {
        value: "345",
        label: "ASTRA POLARIS MFB",
    },
    {
        value: "490",
        label: "AUCHI MICROFINANCE BANK",
    },
    {
        value: "481",
        label: "AZTEC MFB",
    },
    {
        value: "384",
        label: "BANC CORP MICROFINANCE BANK",
    },
    {
        value: "348",
        label: "BAOBAB MFB",
    },
    {
        value: "375",
        label: "BENYSTA MICROFINANCE BANK",
    },
    {
        value: "358",
        label: "BLUEPRINT MFB",
    },
    {
        value: "499",
        label: "BORSTAL MICROFINANCE BANK",
    },
    {
        value: "350",
        label: "BOWEN MICROFINANCE BANK",
    },
    {
        value: "G09",
        label: "BSIC BANK GAMBIA",
    },
    {
        value: "361",
        label: "BUBAYERO MFB",
    },
    {
        value: "346",
        label: "CALABAR MFB",
    },
    {
        value: "496",
        label: "CAPITALMETRIQ SWIFT MFB",
    },
    {
        value: "390",
        label: "CASHRITE MICROFINANCE BANK",
    },
    {
        value: "462",
        label: "CHANGAN RTS MICROFINANCE BANK",
    },
    {
        value: "347",
        label: "CHIBUEZE MFB",
    },
    {
        value: "023",
        label: "CITIBANK NIGERIA LIMITED",
    },
    {
        value: "455",
        label: "CLOUD WALLET",
    },
    {
        value: "497",
        label: "CONSISTENT TRUST MICROFINANCE BANK",
    },
    {
        value: "378",
        label: "CORESTEP MICROFINANCE BANK",
    },
    {
        value: "559",
        label: "CORONATION MERCHANT BANK",
    },
    {
        value: "323",
        label: "COVENANT MICROFINANCE BANK",
    },
    {
        value: "352",
        label: "CROSSRIVER MFB",
    },
    {
        value: "388",
        label: "DELTA TRUST MORTGAGE BANK",
    },
    {
        value: "374",
        label: "EAGLE FLIGHT MICROFINANCE BANK",
    },
    {
        value: "332",
        label: "EBSU MFB",
    },
    {
        value: "050",
        label: "ECOBANK NIGERIA",
    },
    {
        value: "098",
        label: "EKONDO MICROFINANCE BANK",
    },
    {
        value: "EMR",
        label: "EMRINET MOBILE LIMITED",
    },
    {
        value: "500",
        label: "EWT MICROFINANCE BANK",
    },
    {
        value: "381",
        label: "FAST MICROFINANCE BANK",
    },
    {
        value: "FBN-M",
        label: "FBN MICROFINANCE BANK",
    },
    {
        value: "560",
        label: "FBNQUEST MERCHANT BANK",
    },
    {
        value: "512",
        label: "FCMB BETA",
    },
    {
        value: "468",
        label: "FEDETH MICROFINANCE BANK LTD",
    },
    {
        value: "404",
        label: "FETS",
    },
    {
        value: "394",
        label: "FEWCHORE FINANCE COMPANY LIMITED",
    },
    {
        value: "457",
        label: "FHA MORTGAGE BANK LTD",
    },
    {
        value: "070",
        label: "FIDELITY BANK PLC",
    },
    {
        value: "342",
        label: "FINCA MICROFINANCE BANK",
    },
    {
        value: "365",
        label: "FIRMUS MICROFINANCE BANK",
    },
    {
        value: "011",
        label: "FIRST BANK OF NIGERIA PLC",
    },
    {
        value: "214",
        label: "FIRST CITY MONUMENT BANK",
    },
    {
        value: "FGM",
        label: "FIRST GENERATION MORTGAGE BANK LIMITED",
    },
    {
        value: "376",
        label: "FIRST ROYAL MICROFINANCE BANK",
    },
    {
        value: "322",
        label: "FIRSTTRUST MORTGAGE BANK PLC",
    },
    {
        value: "313",
        label: "FORTIS MICROFINANCE BANK",
    },
    {
        value: "501",
        label: "FSDH MERCHANT BANK",
    },
    {
        value: "477",
        label: "GENESIS MICROFINANCE BANK LTD.",
    },
    {
        value: "103",
        label: "GLOBUS BANK",
    },
    {
        value: "396",
        label: "GREENACRES MICROFINANCE BANK LTD",
    },
    {
        value: "060",
        label: "GREENBANK MICROFINANCE BANK",
    },
    {
        value: "430",
        label: "GROOMING MICROFINANCE BANK",
    },
    {
        value: "058",
        label: "GUARANTY TRUST BANK PLC",
    },
    {
        value: "417",
        label: "HAGGAI MORTGAGE BANK",
    },
    {
        value: "096",
        label: "HASAL MICROFINANCE BANK",
    },
    {
        value: "030",
        label: "HERITAGE BANK",
    },
    {
        value: "480",
        label: "IBBU MFB",
    },
    {
        value: "413",
        label: "IBETO MFB",
    },
    {
        value: "479",
        label: "IBOLO MICROFINANCE BANK",
    },
    {
        value: "488",
        label: "IBOM FADAMA MICROFINANCE BANK",
    },
    {
        value: "450",
        label: "IKIRE MICROFINANCE BANK LTD",
    },
    {
        value: "447",
        label: "IMO STATE MICROFINANCE BANK",
    },
    {
        value: "414",
        label: "IMPERIAL HOMES MORTGAGE BANK",
    },
    {
        value: "405",
        label: "INFINITY HOMES",
    },
    {
        value: "494",
        label: "IPERU MICROFINANCE BANK LTD.",
    },
    {
        value: "380",
        label: "ISI UZO MICROFINANCE BANK",
    },
    {
        value: "301",
        label: "JAIZ  BANK PLC",
    },
    {
        value: "304",
        label: "JESSEFIELD MFB",
    },
    {
        value: "321",
        label: "JUBILEE LIFE MORTGAGE BANK",
    },
    {
        value: "492",
        label: "KENECHUKWU MFB",
    },
    {
        value: "082",
        label: "KEYSTONE BANK LTD",
    },
    {
        value: "391",
        label: "KINGDOM COLLEGE MFB",
    },
    {
        value: "451",
        label: "KONTAGORA MICROFINANCE BANK",
    },
    {
        value: "470",
        label: "KREDIMONEY",
    },
    {
        value: "411",
        label: "LA FAYETTE MFB",
    },
    {
        value: "415",
        label: "LAGOS BUILDING INVESTMENT COMPANY MORTGAGE BANK",
    },
    {
        value: "331",
        label: "LAPO MICROFINANCE BANK",
    },
    {
        value: "LVD",
        label: "LAVENDAR MFB",
    },
    {
        value: "427",
        label: "LETSHEGO MICROFINANCE BANK",
    },
    {
        value: "312",
        label: "LIVINGTRUST MORTGAGE BANK",
    },
    {
        value: "303",
        label: "LOTUS BANK LIMITED",
    },
    {
        value: "319",
        label: "MAYFRESH MORTGAGE BANK",
    },
    {
        value: "MGG",
        label: "MEGA BANK GAMBIA",
    },
    {
        value: "355",
        label: "MGBIDI MFB",
    },
    {
        value: "305",
        label: "MICHAEL OKPARA UNIAGRIC MICROFINANCE BANK",
    },
    {
        value: "333",
        label: "MIDLAND MICROFINANCE BANK",
    },
    {
        value: "367",
        label: "MOLUSI MICROFINANCE BANK",
    },
    {
        value: "326",
        label: "MONARCH MFB",
    },
    {
        value: "425",
        label: "MONIEPOINT MICROFINANCE BANK",
    },
    {
        value: "428",
        label: "MUTUAL ALLIANCE MORTGAGE BANK",
    },
    {
        value: "433",
        label: "MUTUAL TRUST MICROFINANCE BANK",
    },
    {
        value: "504",
        label: "NASARAWA MICROFINANCE BANK",
    },
    {
        value: "475",
        label: "NEPTUNE MICROFINANCE BANK",
    },
    {
        value: "386",
        label: "NEWDAWN MFB",
    },
    {
        value: "364",
        label: "NICE MICROFINANCE BANK",
    },
    {
        value: "423",
        label: "NIGERIAN NAVY MICROFINANCE BANK",
    },
    {
        value: "357",
        label: "NIRSAL MFB",
    },
    {
        value: "339",
        label: "NKPOLU UST MFB",
    },
    {
        value: "552",
        label: "NPF MICROFINANCE BANK",
    },
    {
        value: "474",
        label: "NUMO MFB",
    },
    {
        value: "410",
        label: "NWANNEGADI MICROFINANCE BANK",
    },
    {
        value: "324",
        label: "O3CAPITAL MFB",
    },
    {
        value: "509",
        label: "OCTOPUS MICROFINANCE BANK",
    },
    {
        value: "432",
        label: "OGIYAN MFB",
    },
    {
        value: "327",
        label: "OKWO OHA MFB",
    },
    {
        value: "349",
        label: "OLUCHUKWU MFB",
    },
    {
        value: "395",
        label: "OMIYE MFB",
    },
    {
        value: "107",
        label: "OPTIMUS BANK LTD",
    },
    {
        value: "311",
        label: "OSCOTECH MICROFINANCE BANK",
    },
    {
        value: "507",
        label: "PAGA MFB",
    },
    {
        value: "343",
        label: "PAGE MFB",
    },
    {
        value: "104",
        label: "PARALLEX BANK LIMITED",
    },
    {
        value: "314",
        label: "PARKWAY MFB - READYCASH",
    },
    {
        value: "446",
        label: "PEACE MICROFINANCE BANK LTD",
    },
    {
        value: "398",
        label: "PERSONAL TRUST MICROFINANCE BANK",
    },
    {
        value: "076",
        label: "POLARIS BANK",
    },
    {
        value: "397",
        label: "POLYBADAN MICROFINANCE BANK",
    },
    {
        value: "320",
        label: "POLYUNWANA MICROFINANCE BANK",
    },
    {
        value: "PSH",
        label: "POST SERVICES HOME",
    },
    {
        value: "360",
        label: "PREEMINENT MFB",
    },
    {
        value: "105",
        label: "PREMIUM TRUST BANK LTD",
    },
    {
        value: "101",
        label: "PROVIDUS BANK",
    },
    {
        value: "992",
        label: "QUICKTELLER QR VISA",
    },
    {
        value: "RSL",
        label: "RESORT SAVINGS   LOAN PLC",
    },
    {
        value: "336",
        label: "RIMA GROWTH PATHWAY MICROFINANCE BANK",
    },
    {
        value: "403",
        label: "SAFE HAVEN MICROFINANCE BANK",
    },
    {
        value: "463",
        label: "SAFEGATE MICROFINANCE BANK",
    },
    {
        value: "338",
        label: "SAFELINE MFB",
    },
    {
        value: "467",
        label: "SAGAMU MICROFINANCE BANK PLC",
    },
    {
        value: "393",
        label: "SEAP MICROFINANCE BANK",
    },
    {
        value: "093",
        label: "SEEDVEST MICROFINANCE BANK",
    },
    {
        value: "458",
        label: "SHELL COOPLAG",
    },
    {
        value: "106",
        label: "SIGNATURE BANK LTD.",
    },
    {
        value: "506",
        label: "SPARKLE MICROFINANCE BANK",
    },
    {
        value: "369",
        label: "SPECTRUM MICROFINANCE BANK",
    },
    {
        value: "039",
        label: "STANBIC IBTC BANK",
    },
    {
        value: "068",
        label: "STANDARD CHARTERED BANK",
    },
    {
        value: "448",
        label: "STANDARD MICROFINANCE BANK",
    },
    {
        value: "232",
        label: "STERLING BANK PLC",
    },
    {
        value: "399",
        label: "SUNBEAM MICROFINANCE BANK",
    },
    {
        value: "100",
        label: "SUNTRUST BANK",
    },
    {
        value: "471",
        label: "SUPPORT MFB",
    },
    {
        value: "392",
        label: "SUPPORT MICROFINANCE BANK",
    },
    {
        value: "302",
        label: "TAJ BANK",
    },
    {
        value: "335",
        label: "TCF MICROFINANCE BANK",
    },
    {
        value: "102",
        label: "TITAN TRUST BANK",
    },
    {
        value: "486",
        label: "TREASURES MICROFINANCE BANK",
    },
    {
        value: "373",
        label: "TRUSTFUND MFB",
    },
    {
        value: "094",
        label: "UANDC MICROFINANCE BANK",
    },
    {
        value: "062",
        label: "UDA MICROFINANCE BANK",
    },
    {
        value: "489",
        label: "UHURU MICROFINANCE BANK LTD",
    },
    {
        value: "429",
        label: "UKPOR MFB",
    },
    {
        value: "385",
        label: "ULTIMATE MFB",
    },
    {
        value: "416",
        label: "UMUCHINEMERE PROCREDIT MFB",
    },
    {
        value: "377",
        label: "UMUNNACHI MFB",
    },
    {
        value: "095",
        label: "UNICAL MFB",
    },
    {
        value: "316",
        label: "UNILORIN MFB",
    },
    {
        value: "032",
        label: "UNION BANK NIGERIA",
    },
    {
        value: "033",
        label: "UNITED BANK FOR AFRICA",
    },
    {
        value: "215",
        label: "UNITY BANK PLC",
    },
    {
        value: "402",
        label: "UNIUYO MICROFINANCE BANK LTD",
    },
    {
        value: "418",
        label: "UNN STAFF MFB",
    },
    {
        value: "401",
        label: "UZONDU MICROFINANCE BANK",
    },
    {
        value: "354",
        label: "VFD MICROFINANCE BANK",
    },
    {
        value: "M00",
        label: "VFMMFB",
    },
    {
        value: "387",
        label: "VISCOUNT MICROFINANCE BANK",
    },
    {
        value: "482",
        label: "WAYA MICROFINANCE BANK",
    },
    {
        value: "035",
        label: "WEMA BANK PLC",
    },
    {
        value: "309",
        label: "WETLAND \u00a0MICROFINANCE BANK",
    },
    {
        value: "359",
        label: "WINVIEW MICROFINANCE BANK",
    },
    {
        value: "057",
        label: "ZENITH BANK",
    },
    {
        value: "456",
        label: "ZIKORA MICROFINANCE BANK ",
    },
    {
        value: "562",
        label: "ABSU MICROFINANCE BANK",
    },
    {
        value: "063",
        label: "ACCESS(DIAMOND) BANK",
    },
];
export default NGNngpayOptions;
